import React from "react";
import {
  FaClipboard,
  FaIdCard,
  FaUser,
  FaCalendarAlt,
  FaVenusMars,
  FaPhoneAlt,
  FaClinicMedical,
  FaAllergies,
  FaExclamationCircle,
} from "react-icons/fa";
import { calculateAge } from "../../_helper/utils/utils";

const PatientDetails = ({ prescription, date_created }) => {
  console.log("Precription Data", prescription);
  return (
    <div className="bg-white rounded-lg shadow-md p-4 sm:p-6 mb-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800 flex items-center space-x-2">
          <FaClipboard className="text-blue-500" />
          <span>Patient Details</span>
        </h3>
        <div className="text-sm text-gray-500 flex items-center space-x-2">
          <FaCalendarAlt className="text-blue-500" />
          <span>{new Date(date_created).toLocaleString()}</span>
        </div>
      </div>

      {/* Details Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <p className="flex items-center space-x-2 text-gray-600">
          <FaUser className="text-green-500" />
          <span>
            <strong className="text-gray-800">Patient Name:</strong>{" "}
            {prescription?.full_name}
          </span>
        </p>
        <p className="flex items-center space-x-2 text-gray-600">
          <FaCalendarAlt className="text-green-500" />
          <span>
            <strong className="text-gray-800">Age:</strong>{" "}
            {calculateAge(prescription?.dob)?.years || "-"}
          </span>
        </p>
        <p className="flex items-center space-x-2 text-gray-600">
          <FaVenusMars className="text-green-500" />
          <span>
            <strong className="text-gray-800">Gender:</strong>{" "}
            {prescription.gender || "-"}
          </span>
        </p>
        <p className="flex items-center space-x-2 text-gray-600">
          <FaPhoneAlt className="text-green-500" />
          <span>
            <strong className="text-gray-800">Mobile:</strong>{" "}
            {prescription.phone}
          </span>
        </p>
        <p className="flex items-center space-x-2 text-gray-600">
          <FaClinicMedical className="text-green-500" />
          <span>
            <strong className="text-gray-800">Department:</strong>{" "}
            {/* {prescription.department}
             */}
            Pharmacy
          </span>
        </p>
      </div>

      {/* Allergies */}
      <div className="mt-6">
        <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center space-x-2">
          <FaAllergies className="text-red-500" />
          <span>Allergies</span>
        </h4>
        {prescription.allergy && prescription.allergy.length > 0 ? (
          <ul className="list-disc list-inside text-gray-600">
            {prescription?.allergy.map((allergy, index) => (
              <li key={index} className="mb-1 flex items-center space-x-2">
                <FaExclamationCircle className="text-yellow-500" />
                <span>{allergy.name}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-600">No known allergies.</p>
        )}
      </div>
    </div>
  );
};

export default PatientDetails;
